import { render, staticRenderFns } from "./f3.vue?vue&type=template&id=70c43244&scoped=true&"
import script from "./f3.vue?vue&type=script&lang=js&"
export * from "./f3.vue?vue&type=script&lang=js&"
import style0 from "./f3.vue?vue&type=style&index=0&id=70c43244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c43244",
  null
  
)

component.options.__file = "f3.vue"
export default component.exports